import React from 'react';
import Panel from './Panel';
import CompanyList from '../../components/Panel/RegisterCompany/CompanyList';



const CompanyListPage = (e) => {
  let t = e.params.table;

  if (t != undefined && t.length > 0)
    t = e.params.table;
  else
    t = 'all';

  return (
    <Panel>
      <div>
        <CompanyList table={t} />
      </div>
    </Panel>

  );
};

export default CompanyListPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/CompanyListPage.js
 **/